module.exports = __webpack_public_path__ + "static/img/haevichi.4cc7bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/haevichi.jpg
// module id = P5Wj
// module chunks = 0